/** True while a reload would lose work (upload, call, recording, composer, unsaved edit, pending mutation, meeting). */
export function isReloadBlocked(): boolean {
  // Global, not an import: meeting module pulls LiveKit into the root bundle.
  if ((window.__hvaiMeetingFreezeShieldHolders ?? 0) > 0) return true;
  // Busy surfaces cancel beforeunload; synthetic probe asks them without unloading.
  const probe = new Event("beforeunload", { cancelable: true });
  window.dispatchEvent(probe);
  return probe.defaultPrevented;
}
